<mf-page title="Crear reporte para el BCU">
  <mf-form
    [formGroup]="bcuReportForm"
    [closeButtonShow]="true"
    (closeButtonClick)="close()"
    (save)="createBcuReport($event)">
    <mf-row>
      <mf-column [md]="3">
        <mf-field-date
          [maxDate]="today"
          formControlName="startDate" />
      </mf-column>

      <mf-column [md]="3">
        <mf-field-date
          [maxDate]="today"
          formControlName="endDate" />
      </mf-column>

      <mf-column [md]="3">
        <mf-autocomplete-bank
          formControlName="bank"
          [gatewayBanks]="true"
          (itemIdChanged)="bcuReportForm.patchValue({ bankId: $event })" />
      </mf-column>
    </mf-row>
  </mf-form>
</mf-page>
